var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false },
      on: { cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "suspended-modal" }, [
        _c("div", { staticClass: "suspended-modal-title" }, [
          _c("span", { staticClass: "material-icons alert-icon" }, [
            _vm._v("notification_important"),
          ]),
          _vm._v("\n            Hizmetiniz Askıya Alındı\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "suspended-modal-description" }, [
          _c("div", { staticClass: "suspended-modal-description-content" }, [
            _vm._v(
              "\n                Fatura döneminiz sona erdiği için hizmetiniz geçici olarak askıya alınmıştır. Tekrar erişim sağlamak için lütfen gecikmiş ödemenizi tamamlayın.\n\n                "
            ),
            _c(
              "div",
              {
                staticStyle: {
                  color: "#ff4d4d",
                  margin: "15px 0",
                  "font-weight": "bold",
                },
              },
              [
                _vm._v(
                  "\n                    Ödeme süresi: 7 günü aştı\n                "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "suspended-modal-footer" },
          [
            _c(
              "SupsisButton",
              {
                staticStyle: { width: "200px" },
                attrs: { primary: "" },
                on: { click: _vm.confirm },
              },
              [_vm._v("\n                Ödeme Yap\n            ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "font-size": "12px",
                  color: "#666",
                },
              },
              [
                _vm._v(
                  "\n                Not: Faturayı ödedikten sonra hizmetleriniz otomatik olarak aktif hale gelecektir.\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }